import React from "react";
import { Helmet } from "react-helmet";

const SEO = () => {
  return (
    <Helmet>
      {/* Open Graph Metadata */}
      <meta property="og:title" content="Syncrones | Custom Software Development Solutions" />
      <meta
        property="og:description"
        content="Syncrones provides tailored software development services, IT consulting, and custom solutions to empower businesses in the digital era."
      />
      <meta property="og:url" content="https://syncrones.com" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://syncrones.com/logo.jpg" />

      {/* Twitter Metadata */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Syncrones | Custom Software Development Solutions" />
      <meta
        name="twitter:description"
        content="Syncrones specializes in custom software development, IT services, and digital transformation to accelerate your business growth."
      />
      <meta name="twitter:image" content="https://syncrones.com/logo.jpg" />

      {/* Structured Data for Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Syncrones",
          "url": "https://syncrones.com",
          "logo": "https://syncrones.com/logo.jpg",
          "description":
            "Syncrones offers top-tier software development, IT consulting, and custom software solutions to help businesses build innovative and scalable systems.",
          "sameAs": [
            "https://www.facebook.com/syncrones",
            "https://www.linkedin.com/company/syncrones",
            "https://twitter.com/syncrones"
          ],
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
